import addFieldShowHide from './add_field_show_hide.js';

document.addEventListener('DOMContentLoaded', () => {
  const loginForm = document.getElementById('user_session');
  if (!loginForm) return;

  loginForm.addEventListener('submit', () => {
    const submitBtn = loginForm.querySelector('.js-submit-login');
    submitBtn.disabled = true;
  });
  
  // Initialize the password show/hide toggle
  addFieldShowHide();
});
